import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEmploymentPlans } from '../../../../../global/ducks/benadmin-api';
import { AuthenticatedState } from '../../../../../global/models/authenticated-model';
import { BaseAppState } from '../../../../../global/models/redux-state';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { EmploymentState } from '../../employment/employment-model';
import { PensionEnrollmentState } from '../models/pension-enrollment-model';
import { setPensionEnrollmentInfo } from '../pension-enrollment-slice';

export function usePensionEnrollmentInfo() {
    const authenticatedState = useSelector<BaseAppState, AuthenticatedState>(state => state.authenticatedState);
    const employmentState = useSelector<TcsmStates, EmploymentState>(state => state.employmentState);
    const pensionEnrollmentState = useSelector<TcsmStates, PensionEnrollmentState>(state => state.pensionEnrollmentState);
    const dispatch = useDispatch();

    const employmentId = employmentState?.currentEmployee?.employment_id;

    if (employmentId === null) return true;

    const loaded = pensionEnrollmentState?.pensionInfoLoaded;

    useEffect(() => {

        if (employmentId && pensionEnrollmentState && authenticatedState?.accessToken && !loaded) {
            dispatch(getEmploymentPlans(employmentId, (response) => {
                dispatch(setPensionEnrollmentInfo(response));
            }));
        }

    }, [employmentId, loaded]);

    return loaded;
}